export default __webpack_public_path__ + "static/media/roberts.66a91861.png";